export const FREE_VEND_QUOTA_MIN = 1;
export const FREE_VEND_QUOTA_MAX = 200;
export const FREE_VEND_DEFAULT_QUOTA = 50;
export const FREE_VEND_SALE_TYPE = 3;
